import React from 'react';
import PropTypes from 'prop-types';

import {
  FDPrimaryActionButton, FDSecondaryActionButton,
} from '@facet-wealth/design';
import { useFQAdminContext } from 'Views/Page/Content/Templates/FQAdminPanel/FQAdminContext';

const TypeSelectorOption = ({
  resource, relationshipName,
}) => {
  const { isListItemSelected, setListChoice } = useFQAdminContext();
  const isSelected = isListItemSelected(relationshipName);

  const ButtonComponent = isSelected ? FDPrimaryActionButton : FDSecondaryActionButton;

  return resource.withRelationship(relationshipName, (rel) => {
    return (
      <ButtonComponent
        label={rel.meta('prompt')}
        onClick={() => {
          setListChoice(relationshipName);
        }}
      />
    );
  }, () => null);
};

TypeSelectorOption.propTypes = {
  relationshipName: PropTypes.string.isRequired,
  resource: PropTypes.object.isRequired,
};

export { TypeSelectorOption };
